import { render, staticRenderFns } from "./SliderSecond.vue?vue&type=template&id=a1a49998&scoped=true&"
import script from "./SliderSecond.vue?vue&type=script&lang=js&"
export * from "./SliderSecond.vue?vue&type=script&lang=js&"
import style0 from "./SliderSecond.vue?vue&type=style&index=0&id=a1a49998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a49998",
  null
  
)

export default component.exports